import styled from "styled-components";
export const TextContainer = styled.p`
  font-size: 1.8rem;
  color: #6b6f72;
  text-align: center;
  margin: 0;
  font-weight: 400;
  display: block;
  width: 250px;
`;
export const LinkContainer = styled.p`
  font-size: 1.6rem;
  text-align: center;
  font-weight: 600;
  color: #5624d0;
  margin: 2rem 0 0;

  &:hover {
    color: #3b1e96;
  }
`;
